import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Overlay } from '@angular/cdk/overlay';
import { AnnouncementDialogComponent } from './announcement-dialog/announcement-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog,
    private overlay: Overlay
  ) {}

  open(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data,
      scrollStrategy: this.overlay.scrollStrategies.reposition()
    });

    return dialogRef.afterClosed();
  }


    openMemo(data: any): Observable<boolean> {
    const dialogRef = this.dialog.open(AnnouncementDialogComponent, {
      width: '750px',           // Wider for memo content
      maxWidth: '80vw',         // Responsive
      data,
      panelClass: 'memo-dialog', // Custom class for additional styling
      scrollStrategy: this.overlay.scrollStrategies.reposition()
    });

    return dialogRef.afterClosed();
  }

}
